import { Moment } from 'moment';
import { CommonUtils } from '../../utils/common.utils';

export class ExtraCost {
  public uuid = CommonUtils.UUID();

  public orderCostLineId: number;
  public status: number;
  public statusName: string;
  public costType: number;
  public requestedAmount: number;
  public requestedDate: Moment;
  public approvedAmount: number;
  public vatCode: string;
  public approvedDate: Moment;
  public remarks: string;
  public orderId: number;

  constructor() {
    this.uuid = CommonUtils.UUID();
    this.orderCostLineId = null;
    this.status = null;
    this.statusName = null;
    this.costType = null;
    this.requestedAmount = null;
    this.requestedDate = null;
    this.approvedAmount = null;
    this.vatCode = null;
    this.approvedDate = null;
    this.remarks = null;
    this.orderId = 0;
  }
  public static fromObj(obj: any): ExtraCost {
    return Object.assign(new ExtraCost(), obj);
  }
}
